export default "__VITE_ASSET__DW0k4Vhp__"